<template>
  <div id="app">
    <TableGenerator></TableGenerator>
  </div>
</template>

<script>
import TableGenerator from './components/TableGenerator.vue'

export default {
  name: 'App',
  components: {
    TableGenerator
  }
}
</script>

<style>
#app {
  /*font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";*/
  font-family: 'Marcellus SC', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
